__turbopack_context__.v({
  "audioAndCaptions": "TopNavBar-module-scss-module__XSjRCq__audioAndCaptions",
  "backButton": "TopNavBar-module-scss-module__XSjRCq__backButton",
  "backButtonText": "TopNavBar-module-scss-module__XSjRCq__backButtonText",
  "fade": "TopNavBar-module-scss-module__XSjRCq__fade",
  "fade-slide": "TopNavBar-module-scss-module__XSjRCq__fade-slide",
  "iconButton": "TopNavBar-module-scss-module__XSjRCq__iconButton",
  "open-from-center": "TopNavBar-module-scss-module__XSjRCq__open-from-center",
  "progressBarText": "TopNavBar-module-scss-module__XSjRCq__progressBarText",
  "progressBarTextMobile": "TopNavBar-module-scss-module__XSjRCq__progressBarTextMobile",
  "progressBarWrap": "TopNavBar-module-scss-module__XSjRCq__progressBarWrap",
  "spin": "TopNavBar-module-scss-module__XSjRCq__spin",
  "timelineWrapper": "TopNavBar-module-scss-module__XSjRCq__timelineWrapper",
  "topNavBar": "TopNavBar-module-scss-module__XSjRCq__topNavBar",
  "volumeButtonActive": "TopNavBar-module-scss-module__XSjRCq__volumeButtonActive",
});
